export const environment = {
    production: true,
    name: "prod",
    apiPath: 'https://ser4api.azurewebsites.net',
    sitePath: 'http://s4.serapp.com',
    fileServerPath: 'http://ser4files.serapp.com',
    fileManagerPath: 'https://filemanager.serapp.com/ser4/FileManager.aspx',
    fileManagerAPI: 'https://filemanager.serapp.com/ser4',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts